import request from '@/service/request'

/* 桌球室黑名单，分页
* 接口地址准确 因为后端颠颠的，乱来 ，导致羽毛球几个page接口命名不规范
* @params
* */
export const pageSnookerBlockListApi = (params) => {
  return request.post('/stu/snookerBlackUser/page', params)
}

/* 桌球室黑名单 移除黑名单
* @params id
* */
export const unBlockUserSnookerApi = (id) => {
  return request.post(`/stu/snookerBlackUser/remove/${id}`)
}

/* 桌球室黑名单 加入黑名单
* @params userId 来自参数 stuUserId
* */
export const blockUserSnookerApi = (stuUserId) => {
  return request.post('/stu/snookerBlackUser/save', { userId: stuUserId })
}
